import PropTypes from "prop-types";
import React, { Children } from "react";
import styled, { withTheme } from "styled-components";

const StyledPaper = styled.div`
  background-color: ${(props) => props?.theme?.white};
  color: ${(props) => props?.theme?.fg};
  border-radius: ${(props) => (props?.isRound ? "12px" : 0)};
  .card-header {
    margin-right: auto;
  }

  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    border-radius: 0;
    .card-header {
      padding: 0.75rem 1.25rem;
    }
  }
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  .table-image {
    height: 50px;
    margin: 20px 50px 0 0;
  }

  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    border-radius: 0;
    .table-image {
      margin-top: 2px;
      margin-right: 20px;
    }
  }
`;

const Paper = (props) => {
  const { isRound = false, hasSeparator = true, children, image = "" } = props;
  return (
    <StyledPaper
      {...{ isRound }}
      data-testid={props["data-testid"]}
      className={`${props.ultraShadow === false ? "" : " ultra-shadow"}`}
      style={{ textAlign: "left", height: "100%", width: "100%" }}
    >
      <StyledHeader>
        <StyledPaper className="card-header">
          {props.header}
          {hasSeparator && (
            <div
              className={`${
                props.cardHeader ? props.cardHeader : "card-header-separator"
              }`}
            ></div>
          )}
        </StyledPaper>
        {image && <img src={image} alt="logo" className="table-image" />}
      </StyledHeader>
      <div className="card-body align-middle">
        <div className={`${!props.fullBody ? "h-100 w-100" : ""}`}>
          {props.title ? <h3 className="card-title">{props.title}</h3> : ""}
          {props.text ? <p className="card-text">{props.text}</p> : ""}
          <div>
            {Children.map(children, (subChild) => {
              return <>{subChild}</>;
            })}
          </div>
        </div>
      </div>
    </StyledPaper>
  );
};

Paper.propTypes = {
  header: PropTypes.string,
  fullBody: PropTypes.bool,
  fullWidth: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.node,
  isRound: PropTypes.bool,
};

export default withTheme(Paper);
